// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Components
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Card } from "@material-ui/core";

// Components
import Typography from '@material-ui/core/Typography';

interface State {
  stats: any;
}

interface Props {
  pastColor: string;
  futureColor: string;
  data: any;
}

/**
 * @description Home View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(class LocationPeopleChart extends React.Component<Props, State> {

  /**
   * Creates an instance of Home.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: Props) {
    super(props);
    this.state = {
      stats: [
        { "name": 'Personnes totales', "Passé": props.data.total_past, "Futur": props.data.total_futur },
        { "name": 'Nombre adultes', "Passé": props.data.adult_past, "Futur": props.data.total_futur },
        { "name": 'Nombres enfants', "Passé": props.data.children_past, "Futur": props.data.childen_futur }
      ]
    };
  }

  componentWillReceiveProps(props: Props, nextState: State) {
    if (props.data) {
      this.setState({
        stats: [
          { "name": 'Personnes totales', "Passé": props.data.total_past, "Futur": props.data.total_futur },
          { "name": 'Nombre adultes', "Passé": props.data.adult_past, "Futur": props.data.total_futur },
          { "name": 'Nombres enfants', "Passé": props.data.children_past, "Futur": props.data.children_futur }
        ]
      });
    }
  }

  /**
   * @description Render the HomeView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    const { pastColor, futureColor } = this.props;

    return (
      <Card>
        <Typography variant="title" style={{ marginLeft: 10, marginTop: 10 }} gutterBottom={true}>Personnes ayant réservé</Typography>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={this.state.stats}
            margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend wrapperStyle={{
              height: 0
            }} />
            <Bar dataKey="Passé" stackId="a" fill={pastColor} />
            <Bar dataKey="Futur" stackId="a" fill={futureColor} />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/Charts/LocationPeopleChart.tsx